import axios from "axios"
import config from "../../src/config"
import {
  NOTIFICATION_TYPES,
  ToastMessage,
} from "../components/Notification/Notifications"
import _ from "../utils/lodashUtils"
import { dispatchLogout } from "../redux/actionCreators/auth"
import { store } from "../store"
import { FORBIDDEN_USER, SOMETHING_WRONG } from "../constants/notificationMsg"
import { throttle } from "../utils/helpers"
import { INTERVAL_TIME } from "../constants/messages"

/** commented code 👇🏻 for reference of previous API service 
const token = localStorage.getItem('token');

export default axios.create({
    baseURL: config.baseUrl,
    headers: {
        'Content-Type': 'application/json',
        ...(token && { Authorization: `Token ${token}` }),
    },
});
*/
const throttleToastMessage = throttle(ToastMessage, INTERVAL_TIME)
class API {
  static get = (
    route,
    headers,
    hideError = false,
    baseURL = config.baseUrl
  ) => {
    const allHeaders = API.getAllHeaders(headers)
    return API.xhr(route, allHeaders, {}, "get", baseURL, false, {}, hideError)
  }
  static post = (
    route,
    params,
    headers,
    hideError = false,
    baseURL = config.baseUrl
  ) => {
    const allHeaders = API.getAllHeaders(headers)
    return API.xhr(
      route,
      allHeaders,
      params,
      "post",
      baseURL,
      false,
      {},
      hideError
    )
  }

  static put = (
    route,
    params,
    headers,
    hideError = false,
    onUploadProgress = (progressEvent) => {},
    stringify,
    baseURL = config.baseUrl
  ) => {
    const allHeaders = API.getAllHeaders(headers)
    return API.xhr(
      route,
      allHeaders,
      params,
      "put",
      baseURL,
      stringify,
      onUploadProgress,
      hideError
    )
  }

  static patch = (
    route,
    params,
    headers,
    stringify,
    baseURL = config.baseUrl
  ) => {
    const allHeaders = API.getAllHeaders(headers)
    return API.xhr(route, allHeaders, params, "patch", baseURL, stringify)
  }

  static delete = (route, params, headers, baseURL = config.baseUrl) => {
    const allHeaders = API.getAllHeaders(headers)
    return API.xhr(route, allHeaders, params, "delete", baseURL)
  }
  static xhr = (
    route,
    headers,
    params,
    method,
    baseURL = config.baseUrl,
    stringify = false,
    onUploadProgress = (progressEvent) => {},
    hideError = false
  ) => {
    // file object can't be stringified hence using a flag to determine.
    const data = params && stringify ? JSON.stringify(params) : params
    const axiosConfig = {
      method,
      data,
      headers,
      baseURL,
      url: `${route}`,
      timeout: 30000,
      withCredentials: false,
      onUploadProgress,
    }
    axios.interceptors.response.use((response) => {
      if (response && response.status === 500) {
        return response
      }
      return response
    })
    return axios(axiosConfig).catch((error) => {
      API.axiosError(error, hideError)
    })
  }

  static axiosError = (error, hideError = false) => {
    if (error.response && error.response.status === 401) {
      // handle unauthenticated calls here.
      // Log the user out and redirect him to login page
      store.dispatch(dispatchLogout())
    } else if (error.response && error.response.status === 403) {
      // handle unauthorised calls here.
      if (!hideError) {
        ToastMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: FORBIDDEN_USER,
        })
      }
    } else if (_.get(error, "response.status") === 400) {
      if (!hideError) {
        ToastMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: _.get(error, "response.data.error", SOMETHING_WRONG),
        })
      }
    } else if (_.get(error, "response.status") === 404) {
    } else {
      if (!hideError) {
        if (!_.get(error, "response.status", false)) {
          throttleToastMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: _.get(error, "message", SOMETHING_WRONG),
          })
        } else {
          ToastMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: SOMETHING_WRONG,
          })
        }
      }
    }
    throw error
  }

  static getAllHeaders = (headers) => {
    const token = localStorage.getItem("token")
    return {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Token ${token}` }),
      ...headers,
    }
  }
}

export default API
